<template>
  <div
    v-if="cloudStatus"
    class="notifications-container row items-center"
  >
    <cloud-notifications v-if="!cloudIsOffline" />
    <message-notifications />
    <default-password-notify />
  </div>
</template>

<script>
import { useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import { OFFLINE_STATUSES } from '@/views/settings/settingsCloud/cloud.const';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { inject } from 'vue';
import { useUserRolePermissions } from '@/services/UserRolePermissions/UserRolePermissions';
import apolloClient from '@/plugins/GraphQL/Apollo/client';
import { useCommonPersistentDataProvider } from '@/components/common/services/commonDataService';
import DefaultPasswordNotify from '@/components/common/defaultPasswordNotify.vue';
import CloudNotifications from './components/cloud-notifications.vue';
import MessageNotifications from './components/message-notifications.vue';

export default {
  name: 'UserNotifictaions',
  components: {
    DefaultPasswordNotify,
    MessageNotifications,
    CloudNotifications,
  },
  setup() {
    useCommonPersistentDataProvider();
    const userRolePermissions = useUserRolePermissions();
    const coordinatorsService = inject(IKCoordinatorsService);
    const GQL_commonData = useCommonDataQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }));
    return { GQL_commonData, apolloClient, coordinatorsService, userRolePermissions };
  },
  data() {
    return {
      OFFLINE_STATUSES,
    };
  },

  computed: {
    cloudStatus() {
      return this.GQL_commonData?.result?.value?.ibManagerEntities?.settings?.common?.cloud?.cloudStatus;
    },
    cloudIsOffline() {
      return this.OFFLINE_STATUSES.has(this.cloudStatus);
    },
  },
};
</script>

<style lang="scss" scoped>
.notifications-container {
  z-index: 9999;
  height: 48px;
}
</style>
